let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("es3L5")).then(() => parcelRequire('jH0B9'));